// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WzZD","select":"styles_select__1hBWj"};